export const state = () => ({
  chatList: [
    {
      id: 1,
      avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
      name: "Muhammad Migdad",
      time: Date.now() - 4 * 1000, // 4 seconds ago,
      unreadCount: 3,
      content: `<span class="text--primary">Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?`
    },
    {
      id: 2,
      avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
      name: "Abdul Salah",
      time: Date.now() - 8 * 60 * 1000, // 8 minutes ago,
      unreadCount: 2,
      content: `<span class="text--primary">to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend.`
    },
    {
      id: 3,
      avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
      name: "Benjamin Franklyn",
      time: new Date().setHours(11, 20, 0), // 11:20 am,
      unreadCount: 0,
      content:
        '<span class="text--primary">Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?'
    },
    {
      id: 4,
      avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg",
      name: "Benson Bennet",
      time: new Date().setDate(new Date().getDate() - 1), // Yesterday
      unreadCount: 0,
      content:
        '<span class="text--primary">Trevor Hansen</span> &mdash; Have any ideas about what we should get Heidi for her birthday?'
    },
    {
      id: 5,
      avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
      name: "biyomol Shah",
      time: new Date(2024, 4, 12).getTime(), // 12/05/2024
      unreadCount: 0,
      content:
        '<span class="text--primary">Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.'
    },
    {
      id: 6,
      avatar: "https://cdn.vuetifyjs.com/images/lists/6.jpg",
      name: "Christina Brown",
      time: new Date().setDate(new Date().getDate() - 3), // 3 days ago
      unreadCount: 0,
      content:
        '<span class="text--primary">John Doe</span> &mdash; What time is the meeting tomorrow?'
    }
  ],
  chatDetailList: [
    {
      type: "text",
      content:
        "It’s been about 40 minutes! I would like to know the delivery time of my order.",
      isMe: false,
      time: 1689598912517
    },
    {
      type: "text",
      content:
        "I am starving right now. Please try to deliver it as soon as possible.",
      isMe: false,
      time: 1689598912517
    },
    {
      type: "text",
      content:
        "Please wait! Your request is under consideration. Let me manually check what is the status of your order.",
      isMe: true,
      time: 1689598912517
    },
    {
      type: "text",
      content: "Any updates!?",
      isMe: false,
      time: 1689598912517
    },
    {
      type: "text",
      content:
        "It seems your location is experiencing very high traffic. Your order will be delivered at your door step within 5 minutes.",
      isMe: true,
      time: 1689598912517
    },
    {
      type: "text",
      content: "We apologise for the delay 🙏🏼",
      isMe: true,
      time: 1689598912517
    },
    {
      type: "text",
      content: "Why are you delaying it further?",
      isMe: false,
      time: 1711436448471
    },
    {
      type: "text",
      content: "Now the food delivered would have become frozen cold.",
      isMe: false,
      time: 1711436448471
    },
    {
      type: "text",
      content: "I don’t think I’ll be able to accept the order!!!",
      isMe: false,
      time: 1711436448471
    },
    {
      type: "text",
      content: "Hi there!!!",
      isMe: false,
      time: 1711436448471
    }
  ],
  selectedChat: -1
});

export const mutations = {
  SET_CHAT_LIST: function (state, chatList) {
    state.chatList = chatList;
  },
  ADD_TO_CHAT_LIST: function (state, chat) {
    state.chatDetailList.push(chat);
  },
  SET_CHAT_DETAIL_LIST: function (state, chatDetailList) {
    state.chatDetailList = chatDetailList;
  },
  SET_SELECTED_LIST: function (state, selectedChat) {
    state.selectedChat = selectedChat;
  },
  UPDATE_UNREAD_COUNT: function (state, { chatId, unreadCount }) {
    const chatItem = state.chatList.find((item) => item.id === chatId);
    if (chatItem) {
      chatItem.unreadCount = unreadCount;
    }
  }
};
export const actions = {
  sendMsg({ commit }, data) {
    commit("ADD_TO_CHAT_LIST", {
      type: "text",
      content: data.msg,
      time: data.time,
      isMe: true
    });
  },
  markMessagesAsRead({ commit }, chatId) {
    const unreadCount = 0;
    commit("UPDATE_UNREAD_COUNT", { chatId, unreadCount });
  }
};
export const getters = {
  getSelectedChat({ selectedChat, chatList, chatDetailList }) {
    return selectedChat >= 0
      ? { ...chatList[selectedChat], chat: chatDetailList }
      : null;
  }
};
